import React from 'react';
import {
  Button, Dialog, DialogActions, DialogContent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../language/keys';
import AccountLinkedinDialogHeader from './AccountLinkedinDialogHeader';
import { style } from './style';

type AccountLinkedinContainerProps = {
  isShowDialog: boolean,
  onCloseClick: () => void,
  onActionClick: () => void,
  titleHeader: string,
  children: React.ReactElement,
  textBtn: string,
  color: 'primary' | 'secondary',
  disabled?: boolean,
}

export const AccountLinkedinContainer = ({
  isShowDialog,
  onCloseClick,
  onActionClick,
  titleHeader,
  children,
  textBtn,
  color,
  disabled = false,
}:AccountLinkedinContainerProps):JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Dialog
      open={ isShowDialog }
      maxWidth={ style.dialog.maxWidth }
      sx={ style.dialog.sx }
    >
      <AccountLinkedinDialogHeader
        title={ titleHeader }
        onCloseClick={ onCloseClick }
      />
      <DialogContent
        sx={ style.dialog.dialogContent.sx }
      >
        { children }
      </DialogContent>
      <DialogActions sx={ style.dialog.dialogActions.sx }>
        <Button onClick={ onCloseClick }>{translate(STRING_KEYS.CANCEL)}</Button>
        <Button variant="contained"
          sx={ style.action.sx(!!disabled) }
          color={ color }
          onClick={ onActionClick }
        >{ textBtn }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AccountLinkedinContainer.defaultProps = {
  disabled: false,
};
